/**
 * TipoPessoaRecebedorCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {TipoPessoaRecebedor} from '@/model/resource/TipoPessoaRecebedor'

/* TODO: review generated class */
@HttpExclude()
export class TipoPessoaRecebedorCollection extends PageCollection<
  TipoPessoaRecebedor
> {
  constructor() {
    super(TipoPessoaRecebedor)
  }

  queryAsPage() {
    return this.listTipoPessoaRecebedor()
  }

  async listTipoPessoaRecebedor() {
    return await Request.get(`/admin/tipo-pessoa-recebedor`, {
      params: this.params,
    })
      .name('listTipoPessoaRecebedor')
      .as(this)
      .getResponse()
  }

  async listCsvTipoPessoaRecebedor() {
    return await Request.get(`/admin/tipo-pessoa-recebedor/csv`, {
      params: this.params,
    })
      .name('listCsvTipoPessoaRecebedor')
      .as(this)
      .getResponse()
  }
}
